export const SET_PAYMENT_TABLE  = 'SET_PAYMENT_TABLE';
export const UNSET_PAYMENT_TABLE  = 'UNSET_PAYMENT_TABLE';
export const SET_PAYMENT_SUM = 'SET_PAYMENT_SUM';
export const SET_PAYMENT_POSITION = 'SET_PAYMENT_POSITION';
export const TOGGLE_CHECKBOXES = 'TOGGLE_CHECKBOXES';
